module.exports = __webpack_public_path__ + "img/left_bg.d7c6ef9.png";